import { Box, chakra, ImageUploadOutline, rem } from '@bonusly/design-system';

import { CelebrationType } from '../../entities/celebrations';
import { ReactComponent as BirthdayImage } from './assets/birthday-post.svg';
import { ReactComponent as CelebrationIcon } from './assets/celebration-icon.svg';
import { ReactComponent as NewHireImage } from './assets/new-hire-post.svg';
import { ReactComponent as WelcomeImage } from './assets/welcome-post.svg';
import { ReactComponent as WorkAnniversaryImage } from './assets/work-anniversary-post.svg';

const DefaultIcon = chakra(CelebrationIcon);
const ChakraBirthdayImage = chakra(BirthdayImage);
const ChakraWorkAnniversaryImage = chakra(WorkAnniversaryImage);
const ChakraNewHireImage = chakra(NewHireImage);
const ChakraWelcomeImage = chakra(WelcomeImage);
const ChakraImageUploadOutline = chakra(ImageUploadOutline);

export const getCelebrationStyles = (type: CelebrationType) => {
	switch (type) {
		case CelebrationType.Custom:
			return {
				bgColor: 'white',
				iconComponent: <Box bgColor="secondary.bgAlpha" w={rem(38)} h={rem(38)} />,
				imageComponent: <Box bgColor="secondary.bgAlpha" w="284px" h="284px" />,
			};

		case CelebrationType.Birthday:
			return {
				bgColor: 'red.50',
				iconComponent: <DefaultIcon w={rem(38)} h={rem(38)} />,
				imageComponent: <BirthdayImage />,
			};

		case CelebrationType.WorkAnniversary:
			return {
				bgColor: 'purple.50',
				iconComponent: <DefaultIcon w={rem(38)} h={rem(38)} />,
				imageComponent: <WorkAnniversaryImage />,
			};

		case CelebrationType.NewHire:
			return {
				bgColor: 'blue.50',
				iconComponent: <DefaultIcon w={rem(38)} h={rem(38)} />,
				imageComponent: <NewHireImage />,
			};

		case CelebrationType.Welcome:
			return {
				bgColor: 'green.50',
				iconComponent: <DefaultIcon w={rem(38)} h={rem(38)} />,
				imageComponent: <WelcomeImage />,
			};

		default:
			return {
				bgColor: 'white',
				iconComponent: null,
				imageComponent: null,
			};
	}
};

export const getDefaultIcon = (type: CelebrationType) => {
	if (type === CelebrationType.Custom) {
		return ChakraImageUploadOutline;
	}

	return DefaultIcon;
};

export const getDefaultImage = (type: CelebrationType) => {
	switch (type) {
		case CelebrationType.Birthday:
			return ChakraBirthdayImage;
		case CelebrationType.WorkAnniversary:
			return ChakraWorkAnniversaryImage;
		case CelebrationType.NewHire:
			return ChakraNewHireImage;
		case CelebrationType.Welcome:
			return ChakraWelcomeImage;
		default:
			return ChakraImageUploadOutline;
	}
};
